<template>
    <div  v-if="publishingStatus" class="publishInfo"  v-html="publishingStatus">
    </div>
</template>

<script>

    import {TranslationHelper} from "../../../_Base/Utils";
    import SiteCoreItem from "../../../_Api/SiteCoreItem";
    export default{
        data() {
            return {
                translationHelper: {},
                neverPublishFlag: false,
                publishingStatus: ""
            }
        }
        ,created() {
            this.translationHelper = new TranslationHelper(this.$parent.$data.initialTranslations);
            this.neverPublishFlag = this.$parent.$data.neverPublish === "True";
        }
        ,mounted() {
            this.setPublischingInfo()
        }
        ,methods: {
            setPublischingInfo() {
                if (this.neverPublishFlag) {
                    this.publishingStatus = this.translationHelper.getTranslation("camp_PublishStateNeverPublish");
                } else {
                    SiteCoreItem.getPagePublishingState(this.getPagePublishingStateSuccess, this.fetchApiFailure);
                }
            }
            ,getPagePublishingStateSuccess(data){
                if (data && data.publishingJobsWorking) {
                    this.publishingStatus = this.translationHelper.getTranslation("camp_PublishingJobRunning");
                }
                else{
                    this.publishingStatus="";
                }
            }
            ,fetchApiFailure(status, statusText) {
                console.log(statusText);
            }
        }
    }
</script>